import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { SubscriptionModal, SubscriptionFeature } from '../ui/diary/SubscriptionModal';

interface MountOptions {
  /** Unique ID for this prompt (used for session storage) */
  promptId: string;
  /** List of subscription features to display */
  features: SubscriptionFeature[];
  /** URL to view subscription plans */
  subscriptionUrl: string;
  /** URL to dismiss the subscription prompt */
  dismissUrl: string;
  /** CSRF token for API requests */
  csrfToken: string;
  /** Translations for modal content */
  translations: {
    unlockPremiumFeatures: string;
    getUnlimitedAccess: string;
    whatYouGetWithPremium: string;
    viewSubscriptionPlans: string;
    maybeLater: string;
    noCommitment: string;
    close: string;
  };
}

// Store root reference for cleanup
let root: Root | null = null;

export function mountSubscriptionModal(container: HTMLElement, options: MountOptions): void {
  // Clean up previous root if it exists
  if (root) {
    root.unmount();
  }

  root = createRoot(container);
  root.render(
    <SubscriptionModal
      promptId={options.promptId}
      features={options.features}
      subscriptionUrl={options.subscriptionUrl}
      dismissUrl={options.dismissUrl}
      csrfToken={options.csrfToken}
      translations={options.translations}
    />
  );
}

export function unmountSubscriptionModal(): void {
  if (root) {
    root.unmount();
    root = null;
  }
}
